import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { useTrackEvent } from "lib/mixpanel"
import { TRACKING_EVENTS } from "lopermut"
import { LoginResponseDataSchema, SignupSchema } from "schema"
import { z } from "zod"

export const useSignupMutation = () => {
  const trackEvent = useTrackEvent()

  return useMutation({
    mutationFn: async (signupData: z.infer<typeof SignupSchema>) => {
      const { data } = await axios.post("/auth/signup", signupData)

      trackEvent(TRACKING_EVENTS.SIGNUP_COMPLETED, {
        ...signupData,
      })

      return data.data as z.infer<typeof LoginResponseDataSchema>
    },
  })
}
